<template>
  <div class="wrapper">
    <sidebar-menu :linkTo="{name:'home'}" v-if="!blankMode">
      <template slot="logo">
        <img src="/img/logo-workfix.png" id="workfix-logo" alt="Logo">
      </template>
      <ul>
         <li v-if="getAvailableDepartments.length > 1">
          <select  autocomplete="no-fill"  name="" id="" class="form-control" v-model="selectedDepartment">
            <option :value="dep.name" v-for="dep in getAvailableDepartments" :key="dep.name">{{ dep.name }}</option>
          </select>
        </li>
        <router-link tag="li" :to="{name:'home'}" exact>
          <a><i class="fal fa-home"></i> Home</a>
        </router-link>
        <li v-if="Can(rights.USER_VIEW) || Can(rights.ROLE_VIEW)" :class="{'active': isGebruikersbeheerActive || activeMenus.gebruikersbeheer}" @click="toggleMenu('gebruikersbeheer')">
            <a href="#" :aria-expanded="isGebruikersbeheerActive || activeMenus.gebruikersbeheer" class="dropdown-toggle">
                <i class="fal fa-users"></i>
                Gebruikersbeheer
            </a>
            <ul class="collapse list-unstyled" :class="{'show': isGebruikersbeheerActive || activeMenus.gebruikersbeheer}" id="gebruikersSubmenu">
                <router-link v-if="Can(rights.USER_VIEW)" tag="li" :to="{name:'users'}">
                    <a><i class="fal fa-users"></i> Gebruikers</a>
                </router-link>
                <router-link v-if="Can(rights.ROLE_VIEW)" tag="li" :to="{name:'roles'}">
                    <a><i class="far fa-user-tag"></i> Rechten</a>
                </router-link>
            </ul>
        </li>
        <router-link v-if="Can(rights.HOURS_VIEW)" tag="li" :to="{name:'hours'}">
          <a><i class="fal fa-clock"></i> Uren</a>
        </router-link>
        <li v-if="Can(rights.CHAT_VIEW) || Can(rights.METRICS_VIEW)" :class="{'active': isChatActive || activeMenus.chat}" @click="toggleMenu('chat')">
            <a href="#" :aria-expanded="isChatActive || activeMenus.chat" class="dropdown-toggle">
                <i class="fal fa-comments"></i>
                Chat
            </a>
            <ul class="collapse list-unstyled" :class="{'show': isChatActive || activeMenus.chat}" id="chatSubmenu">
                <router-link v-if="Can(rights.CHAT_VIEW)" tag="li" :to="{name:'chat'}">
                  <a><i class="fal fa-comment"></i> Chat</a>
                </router-link>
                <router-link v-if="Can(rights.METRICS_VIEW)" tag="li" :to="{name:'metrics'}">
                  <a><i class="fal fa-ruler"></i> Metrics</a>
                </router-link>
            </ul>
        </li>

        <router-link v-if="Can(rights.DOCUMENT_VIEW)" tag="li" :to="{name:'documents'}">
          <a><i class="fal fa-file"></i> Documenten</a>
        </router-link>

        <router-link v-if="Can(rights.IS_CUSTOMER) || Can(rights.NOTIFICATIONS_VIEW)" tag="li" :to="{name:'notifications'}">
          <a><i class="fal fa-bell"></i> Meldingen <span v-if="newNotifications" class="new-notification"></span></a>
        </router-link>

        <router-link v-if="Can(rights.CONFIG_VIEW)" tag="li" :to="{name:'configuration'}">
          <a><i class="fal fa-cogs"></i> Dienst overzicht</a>
        </router-link>


        <router-link v-if="Can(rights.OTHER_POOL_VIEW)" tag="li" :to="{name:'pools'}" exact>
          <a><i class="fal fa-user-clock"></i> Poule</a>
        </router-link>
        <router-link v-if="Can(rights.VACANCY_VIEW)" tag="li" :to="{name:'vacancies'}">
        <a><i class="fal fa-file-contract"></i> Vacatures</a>
      </router-link>

        <router-link v-if="Can(rights.CANDIDATE_VIEW)" tag="li" :to="{name:'candidates'}">
          <a><i class="fal fa-users"></i> Flexwerkers</a>
        </router-link>
        <li v-if="Can(rights.EXPERIENCE_VIEW) || Can(rights.CERTIFICATE_VIEW) || Can(rights.EDUCATION_VIEW) || Can(rights.COSTCENTER_VIEW)" :class="{'active': isOpmaakActive || activeMenus.opmaak}" @click="toggleMenu('opmaak')">
            <a href="#" :aria-expanded="isOpmaakActive || activeMenus.opmaak" class="dropdown-toggle">
                <i class="fal fa-paint-brush"></i>
                Opmaak
            </a>
            <ul class="collapse list-unstyled" :class="{'show': isOpmaakActive || activeMenus.opmaak}" id="opmaakSubmenu">
                <router-link v-if="Can(rights.EXPERIENCE_VIEW)" tag="li" :to="{name:'experiences'}">
                  <a><i class="fal fa-archive"></i> Ervaringen</a>
                </router-link>
                <router-link v-if="Can(rights.CERTIFICATE_VIEW)" tag="li" :to="{name:'certificates'}">
                  <a><i class="fal fa-file-certificate"></i> Certificaten</a>
                </router-link>
                <router-link v-if="Can(rights.EDUCATION_VIEW)" tag="li" :to="{name:'educations'}">
                  <a><i class="fal fa-graduation-cap"></i> Opleidingen</a>
                </router-link>
                <router-link v-if="Can(rights.COSTCENTER_VIEW)" tag="li" :to="{name:'costCenters'}">
                  <a><i class="fal fa-coins"></i> Kostenplaatsen</a>
                </router-link>
            </ul>
        </li>
        <router-link v-if="Can(rights.IS_ADMIN)" tag="li" :to="{name:'email-config'}">
          <a><i class="fal fa-envelope-open-text"></i> E-mail configuratie</a>
        </router-link>
        <router-link v-if="Can(rights.CUSTOMER_VIEW)" tag="li" :to="{name:'customers'}">
          <a><i class="fal fa-building"></i> Klanten</a>
        </router-link>
        <router-link v-if="Can(rights.CANDIDATE_VIEW)" tag="li" :to="{name:'customer-visits'}">
          <a><i class="fal fa-handshake"></i> Klantbezoeken <span v-if="hasNonRecentCustomerVisits" class="new-notification"></span></a>
        </router-link>
        <router-link v-if="Can(rights.CONTRACTS_VIEW)" tag="li" :to="{name:'contracts'}">
          <a><i class="fal fa-file"></i> Contracten </a>
        </router-link>
        <router-link v-if="Can(rights.OTHER_APPOINTMENT_VIEW)" tag="li" :to="{name:'appointments'}">
          <a><i class="fal fa-calendar-alt"></i> Afspraken</a>
        </router-link>
        <router-link v-if="Can(rights.BLACKLIST_VIEW)" tag="li" :to="{name:'blacklist'}">
          <a><i class="fal fa-exclamation-triangle"></i> Blacklist</a>
        </router-link>
        <router-link v-if="Can(rights.OTHER_QUITTERS_VIEW)" tag="li" :to="{name:'quitters'}">
          <a><i class="fal fa-door-open"></i> Stoppers</a>
        </router-link>
        <router-link v-if="Can(rights.SMS_HISTORY_VIEW)" tag="li" :to="{name:'smsHistory'}">
          <a><i class="fal fa-sms"></i> Sms berichten</a>
        </router-link>
        <!--        <router-link v-if="Can(rights.MAILING_LIST_VIEW)" tag="li" :to="{name:'mailinglist'}">-->
        <!--          <a><i class="fal fa-at"></i> Maillijst</a>-->
        <!--        </router-link>-->
        <router-link v-if="Can(rights.OTHER_IMPORT_ADD)" tag="li" :to="{name:'import'}">
          <a><i class="fal fa-cloud-upload"></i> Importeren</a>
        </router-link>
        <router-link v-if="Can(rights.ANALYTICS_VIEW)" tag="li" :to="{name:'analytics'}">
          <a><i class="fas fa-chart-line"></i> Analytics</a>
        </router-link>
      </ul>
    </sidebar-menu>

    <topbar :class="{'blankMode': blankMode}">
      <a slot="left" href="javascript:" id="sidebarCollapse" @click="collapsed = !collapsed">
        <i class="fal" :class="[collapsed ? 'fa-bars' : 'fa-align-left']"></i>
      </a>
      <template slot="right">
        <ul>
          <li class="dropdown">
            <a data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
              <i class="fi flaticon-user-1"></i> <span class="userLoggedIn">{{ loggedInUser }}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-right mt-0">
              <template v-if="mayUseBlankMode()">
                <router-link tag="a" :to="{name:'blank'}" class="dropdown-item">
                  Blanco Modus
                </router-link>


                <div class="dropdown-divider"></div>
              </template>


              <a href="javascript:;" class="dropdown-item" @click="$ApiClient.logout()">Uitloggen</a>
            </div>
          </li>
        </ul>
      </template>
    </topbar>

    <div id="m-content">
      <vue-page-transition name="fade">
        <router-view></router-view>
      </vue-page-transition>
    </div>

    <root-mocker v-if="getMe.root" :companyList="$store.state.root.companies"></root-mocker>
    <loading-screen :size="100" :animationDuration="3000"></loading-screen>
<!--    <isAuthenticated :dataApi="api"></isAuthenticated>-->
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from 'moment';
import {RootMocker, LoadingScreen, SidebarMenu, Topbar} from "motivate-framework-components";
import {Can} from "../permission/ability";
import {RIGHTS} from "./views/roles/rights";
import firebase from "firebase";
import Vue from 'vue'
import store from "@/store";
import Apiclient from "@/api-wrapper";
import {mayUseBlankMode, shouldResumeBlankMode} from "@/utils/blankMode";

var MD5 = require("crypto-js/md5");
export default {
  components: {
    SidebarMenu,
    Topbar,
    RootMocker,
    LoadingScreen
  },
  data() {
    return {
      collapsed: false,
      blankMode: false,
      selectedDepartment: null,
      rights: '',
      newNotifications: false,
      fetchDataInterval: null,
      activeMenus: {
        gebruikersbeheer: false,
        chat: false,
        opmaak: false
      }
    }
  },
  computed: {
    api() {
      return DATA_API
    },
    getAvailableDepartments() {
      return this.$store.state.users.me.departments
    },
    ...mapGetters('users', ['getMe']),
    ...mapGetters('customers', ['getCustomers']),
    ...mapGetters('customerContactMoments', ['getCustomerContactMoments']),
    ...mapGetters('portalConfig', ['getConfigByDepartment']),
    hasNonRecentCustomerVisits: function() {
      var dept = this.$store.state.users.me.selectedDepartment;
      var deptConfig = this.getConfigByDepartment(dept);
      var thresholdWeeks = deptConfig && deptConfig.recentThresholdWeeks != null ? deptConfig.recentThresholdWeeks : 4;
      var momentsByCustomer = this.getCustomerContactMoments.reduce(function(map, m) {
        if (!map[m.customerId]) map[m.customerId] = [];
        map[m.customerId].push(m);
        return map;
      }, {});
      return this.getCustomers.some(function(customer) {
        if (customer.activeCustomer === false) return false;
        var visits = (momentsByCustomer[customer.id] || []).sort(function(a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        if (!visits.length) return true;
        return moment().diff(moment(visits[0].created_at), 'weeks') >= thresholdWeeks;
      });
    },
    isGebruikersbeheerActive() {
      return ['users', 'roles'].includes(this.$route.name);
    },
    isOpmaakActive() {
      return ['experiences', 'certificates', 'educations', 'costCenters'].includes(this.$route.name);
    },
    isChatActive() {
      return ['chat', 'metrics'].includes(this.$route.name);
    },
    loggedInUser() {
      let user = this.$store.state.users.me;
      return user.firstname + ' ' + user.lastname
    },
  },
  methods: {
    Can,
    mayUseBlankMode,
    toggleMenu(menu) {
      this.activeMenus[menu] = !this.activeMenus[menu];
    },
    async fetchData() {
      await store.dispatch('notifications/getNotifications', { ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments }).then((res) => {
        if (res.status === 200) {
          this.newNotifications = res.data.data.length > 0;
        }
      });
    }
  },
  mounted() {
    // Listen for global refresh notification event
    this.$root.$on('refresh-notifications', this.fetchData);
  },
  beforeDestroy() {
    this.$root.$off('refresh-notifications', this.fetchData);
  },
  watch: {
    async selectedDepartment(newV, oldV) {
      if (oldV) {
        await this.$FB.collection('UserData').doc(this.$store.state.users.me.id).update({
          selectedDepartment: newV
        })
        await this.$store.dispatch('closeApp')
        location.reload(true)
      }
    },
    $route() {
      for (const menu in this.activeMenus) {
        this.activeMenus[menu] = false;
      }
    }
  },

  created() {
    const self = this
    setInterval(async () => {
          var user = firebase.auth().currentUser;
          if (user) {
            let oldToken = MD5(localStorage.getItem('firebaseToken')).toString()


            Vue.prototype.$USER.getIdTokenResult(/* forceRefresh */ true).then(async function (idToken) {
              let newToken = MD5(idToken.token).toString()
              let res = await self.$FB.collection('TwoFactorCodes').where('accessToken', '==', oldToken).get()
              for (let i = 0; i < res.docs.length; i++) {
                let doc = res.docs[i]
                await doc.ref.update({
                  accessToken:newToken
                })
              }

              // console.log(idToken.token);

              // console.log(localStorage.getItem('firebaseToken'))
              localStorage.setItem('firebaseToken', idToken.token);
              Vue.prototype.$FB_ID_TOKEN = idToken.token;
              self.$store.commit('setOauthToken',idToken.token)
              var options = {
                REDIRECT_URI: process.env.VUE_APP_REDIRECT_URI,
                CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
                baseURL: process.env.VUE_APP_AC_API,
                version: 'v1',
                token: idToken.token,
                store: store,
                CLOUD_API: process.env.VUE_APP_CLOUD_API,
              };


              Vue.prototype.$ApiClient =  Apiclient(options);
            })
          }
        },
         1000 * 60 * 30
    );
    this.fetchDataInterval = setInterval(async () => {
      this.$root.$emit('refresh-notifications');
    }, 1000 * 30);
    self.fetchData()
    this.rights = RIGHTS;
    if (shouldResumeBlankMode()) {
      this.$router.push("/blank");
    }
    this.selectedDepartment = this.$store.state.users.me.selectedDepartment
  },
  destroyed() {
    clearInterval(this.fetchDataInterval);
  }
}
</script>

<style lang="scss">
@import "./assets/scss/_customFramework";

.new-notification {
  width: 10px;
  height: 10px;
  background-color: orange;
  border-radius: 50%;
  display: inline-block;
  margin-left: 5px;
}

</style>